export const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    }, root: {
        display: "flex",
        flexWrap: "wrap"
    }, margin: {
        margin: theme.spacing.unit
    },
    formControl: {
        minWidth: '194px'
    },
    marginLeft :{
        marginLeft: theme.spacing.unit
    },withoutLabel: {
        marginTop: theme.spacing.unit * 3
    }, textField: {
        flexBasis: 200
    }, topBarButton: {
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
    }, toggleMapButton: {
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
        width: '817px'
    }, plainWhiteButton: {
        color: '#000',
        borderWidth: 'thin',
        backgroundColor: '#ffffff',
        width: '200px'
    }, clearPolygonButton: {
        color: '#000',
        borderWidth: 'thin',
        '&:hover': {
          backgroundColor: '#EE5353',
          // borderColor: '#B2B2B2',
        },
        // backgroundColor: '#EE5353',
    }, mapContainer: {
        backgroundColor: '#ebf0f4',
        borderStyle: 'solid',
        borderColor:'#4589b6',
        borderWidth: 'thin',
        width: '815px',
        marginTop: '-10px'
    }, metOptionsContainer: {
        width: '815px',
    }, toggleAdvancedOptionsButton: {
        // color: '#212121',
        // borderColor: '#878787',
        // borderWidth: 'thin',
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: '#EDEDED',
          borderColor: '#B2B2B2',
        },
        width: '817px'
    }
    , advancedOptionsContainer: {
        // backgroundColor: '#EDEDED',
        borderBottomStyle: 'solid',
        borderLeftStyle: 'solid',
        borderRightStyle: 'solid',
        borderColor:'#B2B2B2',
        borderWidth: 'thin',
        width: '815px',
        marginTop: '-10px'
    }
});


export function validateRequestBody(formInputs) {

    if (formInputs['runOption'] === null ){
        return  "Please choose a model."
    }
}

export function translateRequestBody(formInputs) {
    let requestBody = {
        "runOption": formInputs["runOption"],
        "sdate": formInputs["sdate"],
        "edate": formInputs["edate"],
        "grid": formInputs["grid"],
    };

    return requestBody
}
